import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/common/PrivateRoute';
import AppLayout from './components/layout/AppLayout';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Endpoints from './pages/endpoints/Endpoints';
import Eventos from './pages/eventos/Eventos';
import Quarentena from './pages/quarentena/Quarentena';
import Cadastros from './pages/cadastros/Cadastros';
import Documentacao from './pages/documentacao/Documentacao';
import EventoDetalhe from './pages/eventos/EventoDetalhe';
import Usuarios from './pages/usuarios/Usuarios';
import Auditoria from './pages/auditoria/Auditoria';
import Perfil from './pages/perfil/Perfil';

function PrivateLayout({ children, perfil }) {
  return (
    <PrivateRoute perfil={perfil}>
      <AppLayout>{children}</AppLayout>
    </PrivateRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <PrivateLayout>
                <Dashboard />
              </PrivateLayout>
            }
          />
          <Route
            path="/endpoints"
            element={
              <PrivateLayout>
                <Endpoints />
              </PrivateLayout>
            }
          />
          <Route
            path="/eventos"
            element={
              <PrivateLayout>
                <Eventos />
              </PrivateLayout>
            }
          />
          <Route
            path="/eventos/:idEvento"
            element={
              <PrivateLayout>
                <EventoDetalhe />
              </PrivateLayout>
            }
          />
          <Route
            path="/quarentena"
            element={
              <PrivateLayout perfil="operador">
                <Quarentena />
              </PrivateLayout>
            }
          />
          <Route
            path="/cadastros/clientes"
            element={
              <PrivateLayout perfil="operador">
                <Cadastros
                  tipo="cliente"
                  titulo="Clientes"
                  subtitulo="Para quem são as integrações — o mesmo sistema costuma atender vários"
                  placeholder="Nome do cliente"
                />
              </PrivateLayout>
            }
          />
          <Route
            path="/cadastros/sistemas"
            element={
              <PrivateLayout perfil="operador">
                <Cadastros
                  tipo="sistema"
                  titulo="Sistemas"
                  subtitulo="Com o que as integrações falam — Tiny, WooCommerce, Asaas..."
                  placeholder="Nome do sistema"
                />
              </PrivateLayout>
            }
          />
          <Route
            path="/usuarios"
            element={
              <PrivateLayout perfil="operador">
                <Usuarios />
              </PrivateLayout>
            }
          />
          <Route
            path="/auditoria"
            element={
              <PrivateLayout perfil="admin">
                <Auditoria />
              </PrivateLayout>
            }
          />
          <Route
            path="/documentacao"
            element={
              <PrivateLayout>
                <Documentacao />
              </PrivateLayout>
            }
          />
          <Route
            path="/perfil"
            element={
              <PrivateLayout>
                <Perfil />
              </PrivateLayout>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
